module.exports = __webpack_public_path__ + "static/bankole-4818367a480fc162646f66ec16f5056c.png";